import { render, staticRenderFns } from "./BodyMapCanvas.vue?vue&type=template&id=5245555e&scoped=true&"
import script from "./BodyMapCanvas.vue?vue&type=script&lang=ts&"
export * from "./BodyMapCanvas.vue?vue&type=script&lang=ts&"
import style0 from "./BodyMapCanvas.vue?vue&type=style&index=0&id=5245555e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5245555e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VBtnToggle,VIcon,VSelect,VSpacer})
